<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/l-audio/l-audio.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">奢华系列音响系统展架</div>
                <div class="detail-banner-desc">文案待提供。</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            7.3.6奢华级音响系统方案可视化展示，精选功放及特色扬声器陈列
                        </div>
                        <div>
                            自研产品，平台化设计，成熟可靠的量产解决方案
                        </div>
                        <div>
                            实现奢华音效体验
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/l-audio/l-audio-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-full">
                                    <div class="v">AD20 20CH DSP功放</div>
                                    <div class="k">功放</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">AD12 12CH DSP功放</div>
                                    <div class="k">功放</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">2CH分立Booster</div>
                                    <div class="k">功放</div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                
                                <div class="spec-item spec-item-full">
                                    <div class="v">25mm豪华高音</div>
                                    <div class="k">扬声器</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">30mm顶棚超薄中高频</div>
                                    <div class="k">扬声器</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">65mm豪华环绕</div>
                                    <div class="k">扬声器</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">100mm豪华中置中音</div>
                                    <div class="k">扬声器</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">100mm豪华门中音</div>
                                    <div class="k">扬声器</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/l-audio/l-audio-1.jpg" alt="200-1-02">
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/l-audio/l-audio-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">

                                <div class="spec-item spec-item-full">
                                    <div class="v">130mm双核重低音</div>
                                    <div class="k">扬声器</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">224mm豪华后置重低音</div>
                                    <div class="k">扬声器</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">165mm豪华三分频门低音</div>
                                    <div class="k">扬声器</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '奢华系列音响系统展架 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/l-audio.html'
};

import { createApp } from 'vue';
import App from './l-audio.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./l-audio.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
